import React from 'react';
import { useNavigate } from 'react-router-dom';
import SEOHead from './SEOHead';
import Hero from './Hero';
import HowWeWork from './HowWeWork';
import ClientSuccess from './ClientSuccess';
import BlogPreview from './BlogPreview';
import FinalCTA from './FinalCTA';

const Home = () => {
  const navigate = useNavigate();

  const handleNavigation = (page, section = null) => {
    if (section) {
      navigate(`/${page}#${section}`);
    } else {
      navigate(`/${page}`);
    }
  };
  return (
    <div>
      <SEOHead 
        title="MedQuore - Medical Device Quality & Compliance Experts | ISO 13485, EU MDR"
        description="Leading medical device quality and compliance company. Expert ISO 13485, EU MDR, FDA consulting. Quality assurance, audits, gap assessments for global MedTech."
        keywords="medical device quality, ISO 13485, EU MDR, FDA compliance, quality assurance, medical device consulting, regulatory affairs, audit support"
        canonical="https://medquore.com/"
        ogTitle="MedQuore - Medical Device Quality & Compliance Experts"
        ogDescription="Leading the way in safety and quality for medical devices, drugs, and biologics. Trusted partner for global MedTech companies."
      />
      <Hero onNavigate={handleNavigation} />
      <HowWeWork onNavigate={handleNavigation} />
      {/* <ClientSuccess /> - Hidden temporarily */}
      <BlogPreview onNavigate={handleNavigation} />
      <FinalCTA onNavigate={handleNavigation} />
    </div>
  );
};

export default Home;